export enum EnumTpLancamentoSessaoValor {
    SUPRIMENTO = 0,
    SANGRIA = 1,
    ABERTURA = 2,
    FECHAMENTO = 3,
    DESPESA = 5,
    RECEITA = 6,
    GORJETA = 7
}